export default "__VITE_ASSET__BUsAnzB7__"